import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { StartProjectInstructionsDialogComponent } from '../start-project-instructions-dialog/start-project-instructions-dialog.component';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  showInstructionsButton?: boolean;
  instructionsData?: { project: any; dataSource: any };
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="app-dialog confirm-dialog">
      <div class="app-dialog__heading">
        <button
          mat-icon-button
          type="button"
          class="confirm-dialog-close"
          aria-label="Close"
          (click)="onCancel()">
          <mat-icon>close</mat-icon>
        </button>
        <div class="app-dialog__heading-copy">
          <span class="app-dialog__eyebrow">Confirmation</span>
          <div class="app-dialog__title-row">
            <div class="app-dialog__title-copy">
              <h2 mat-dialog-title class="app-dialog__title">{{ data.title }}</h2>
            </div>
          </div>
        </div>
      </div>

      <mat-dialog-content class="app-dialog__content">
        <p>{{ data.message }}</p>
      </mat-dialog-content>

      <mat-dialog-actions class="app-dialog__actions confirm-dialog-actions" align="end">
        <button
          *ngIf="data.showInstructionsButton"
          mat-stroked-button
          color="primary"
          type="button"
          (click)="onViewInstructions()"
          class="instructions-btn">
          View API Instructions
        </button>
        <div class="action-buttons">
          <button mat-button type="button" (click)="onCancel()">{{ data.cancelText }}</button>
          <button mat-raised-button color="primary" type="button" (click)="onConfirm()">{{ data.confirmText }}</button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  styles: [`
    .confirm-dialog {
      width: 100%;
    }

    .confirm-dialog .app-dialog__content {
      min-width: 0;
    }

    .confirm-dialog-close {
      position: absolute !important;
      top: 12px !important;
      right: 16px !important;
      z-index: 1;
      color: var(--text-secondary);
    }

    mat-dialog-content {
      margin: 0;
    }
    
    mat-dialog-content p {
      line-height: 1.5;
      margin: 0;
    }
    
    .confirm-dialog-actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
    }
    
    .instructions-btn {
      margin-right: auto;
    }
    
    .action-buttons {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private dialog: MatDialog
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onViewInstructions(): void {
    if (this.data.instructionsData) {
      this.dialog.open(StartProjectInstructionsDialogComponent, {
        width: '800px',
        maxWidth: '90vw',
        height: '80vh',
        data: this.data.instructionsData
      });
    }
  }
}
